import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import QRCode from "react-qr-code";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Link } from "react-router-dom";
import api from "../../api";
import {
  handleDownloadReceipt,
  handleShareReceipt,
} from "../../utils/receiptUtils";
import "./payment.css";
import { useTheme } from "../../components/header/header";

import Button from "../../components/button/button";

import img1 from "./img/1.png";
import img2 from "./img/2.png";
import back from "./img/back.svg";
import backDark from "./img/back-dark.svg";

import loader from "./img/loader.svg";
import copy from "./img/copy.svg";
import copyDark from "./img/copy-dark.svg";
import copyDone from "./img/copy-done.svg";
import copyDoneDark from "./img/copy-done-dark.svg";
import strike from "./img/strike.png";
import strikeDark from "./img/strike-dark.png";
import cash from "./img/cash.png";
import wallet from "./img/wallet.png";

import download from "./img/download.svg";
import downloadDark from "./img/download-dark.svg";
import share from "./img/share.svg";
import shareDark from "./img/share-dark.svg";

const Payment = () => {
  const { theme } = useTheme();
  const [step, setStep] = useState(0);
  const [selectedCard, setSelectedCard] = useState(null);
  const [error, setError] = useState("");
  const user_id = localStorage.getItem("user_id");
  const note = localStorage.getItem("note");
  const amountString = localStorage.getItem("amountValue").replace("$", "");
  const [sendingAddress, setSendingAddress] = useState("");
  const [invoiceId, setInvoiceId] = useState("");
  const [transactionDetails, setTransactionDetails] = useState({});
  const [isCopied, setIsCopied] = useState(false);
  const currency = "USD";
  const intervalRef = useRef(null);

  const userIdNumber = parseInt(user_id, 10);
  const amount = parseFloat(amountString);
  const navigate = useNavigate();

  useEffect(() => {
    const hasReloaded = localStorage.getItem("hasReloaded");

    if (!hasReloaded) {
      window.location.reload();
      localStorage.setItem("hasReloaded", "true");
    }

    return () => {
      localStorage.removeItem("hasReloaded");
    };
  }, []);

  const handleCopy = () => {
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 3000);
  };

  const handleCardSelect = (card) => {
    setSelectedCard(card);
  };

  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const token = localStorage.getItem("token");

      const response = await api.post(
        "/api/transactions",
        {
          user_id: userIdNumber,
          amount: amount,
          currency: currency,
          payment_method: selectedCard,
          note: note,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const { transaction_id, sending_address, invoice_id } = response.data;
      setSendingAddress(sending_address);
      setInvoiceId(invoice_id);

      setStep(1);

      const checkTransactionStatus = async () => {
        await fetchTransactionDetails(transaction_id);
      };

      await checkTransactionStatus();
      intervalRef.current = setInterval(checkTransactionStatus, 1000);

    } catch (err) {
      if (err.response) {
        setError(err.response.data.error.message);
      } else {
        setError("An error occurred.");
      }
    }
  };

  const fetchTransactionDetails = async (transactionId) => {
    try {
      const token = localStorage.getItem("token");

      const response = await api.get(
        `/api/transactionDetails/${transactionId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setTransactionDetails(response.data);

      console.log(response.data.status);
      if (response.data.status === "COMPLETED") {
        clearInterval(intervalRef.current);
        setStep(2);
      }
    } catch (err) {
      clearInterval(intervalRef.current);
      if (err.response) {
        setError(err.response.data.error.message);
      } else {
        setError("An error occurred while fetching transaction details.");
      }
    }
  };

  const AddressInput = ({ sendingAddress }) => {
    const maxLength = 30;

    const truncatedAddress =
      sendingAddress.length > maxLength
        ? `${sendingAddress.slice(0, maxLength / 2)}...${sendingAddress.slice(
            -maxLength / 2
          )}`
        : sendingAddress;

    return (
      <div className="addressInput">
        <span>{truncatedAddress}</span>
        <CopyToClipboard text={sendingAddress} onCopy={handleCopy}>
          <img
            className="addressCopy"
            src={
              isCopied
                ? theme === "light"
                  ? copyDone
                  : copyDoneDark
                : theme === "light"
                ? copy
                : copyDark
            }
            alt="copy"
          />
        </CopyToClipboard>
      </div>
    );
  };

  return (
    <>
      <div className="headerPayment">
        {step === 0 && (
          <>
            <Link className="backBtn" to={"/deposit"}>
              <img src={theme === "light" ? back : backDark} alt="back" />
            </Link>
            <div className="title">Payment method</div>
          </>
        )}
        {step === 1 && (
          <>
            <div className="backBtn" onClick={() => setStep(0)}>
              <img src={theme === "light" ? back : backDark} alt="back" />
            </div>
            <div className="headerWrap">
              <div className="title">Payment waiting</div>
              <img className="headerLoader" src={loader} alt="loader" />
            </div>
          </>
        )}
        {step === 2 && (
          <div className="headerWrap">
            <div className="title">Payment completed</div>
            <img className="headerLoader" src={loader} alt="loader" />
          </div>
        )}
      </div>
      <div className="container">
        {step === 0 && (
          <>
            <div className="text">
              Choose a way you would like to use to send your&nbsp;payment:
            </div>
            <div className="wrap">
              <div className="cardsWrap">
                <div
                  className={`card ${
                    selectedCard === "lightning" ? "selected" : ""
                  }`}
                  onClick={() => handleCardSelect("lightning")}
                >
                  <img src={img1} alt="Lightning Bitcoin" />
                  <div>Lightning Bitcoin</div>
                </div>
                <div
                  className={`card ${
                    selectedCard === "bitcoin" ? "selected" : ""
                  }`}
                  onClick={() => handleCardSelect("bitcoin")}
                >
                  <img src={img2} alt="Bitcoin" />
                  <div>Bitcoin</div>
                </div>
              </div>
              <div>
                <Button
                  disabled={selectedCard === null}
                  text={"Continue"}
                  onClick={handleSubmit}
                ></Button>
                {error && <div className="error">{error}</div>}
              </div>
            </div>
          </>
        )}

        {step === 1 && (
          <div className="paymentWaiting">
            <div className="qr">
              <QRCode
                value={sendingAddress}
                style={{ height: "auto", maxWidth: "100%", width: "auto" }}
              />
            </div>
            <div className="address">
              <div className="addressText">Sending address</div>
              <AddressInput sendingAddress={sendingAddress} />
            </div>
            <div className="data">
              <div className="dataInvoiceId">Invoice ID: {invoiceId}</div>
              <div className="dataText">Amount: {amount} USD</div>
            </div>

            <div>
              <div className="methodsTitle">or Pay With:</div>
              <div className="methodsWrap">
                <a
                  className="method"
                  href={`strike:${selectedCard}:${sendingAddress}`}
                >
                  <img
                    className="methodImg"
                    src={theme === "light" ? strike : strikeDark}
                    alt="strike"
                  />
                  <div className="methodText">Strike.me</div>
                </a>
                <a
                  className="method"
                  href={`squarecash:${selectedCard}:${sendingAddress}`}
                >
                  <img className="methodImg" src={cash} alt="cash app" />
                  <div className="methodText">Cash App</div>
                </a>
                <a
                  className="method"
                  href={`bluewallet:${selectedCard}:${sendingAddress}`}
                >
                  <img className="methodImg" src={wallet} alt="blue wallet" />
                  <div className="methodText">BlueWallet</div>
                </a>
              </div>
            </div>
          </div>
        )}

        {step === 2 && (
          <div className="paymentCompleted">
            <div className="borderWrap">
              {transactionDetails && (
                <div className="table">
                  <div className="tableRow">
                    <div>Invoice ID:</div>
                    <div>{transactionDetails.invoice_id?.slice(0, 5)}</div>
                  </div>
                  <div className="tableRow">
                    <div>Cashier ID:</div>
                    <div>{transactionDetails.cashier_id}</div>
                  </div>
                  <div className="tableRow">
                    <div>Date/Time:</div>
                    <div>
                      {(() => {
                        const date = new Date(transactionDetails.created_at);
                        const day = String(date.getDate()).padStart(2, "0");
                        const month = String(date.getMonth() + 1).padStart(
                          2,
                          "0"
                        );
                        const year = String(date.getFullYear()).slice(-2);

                        const hours = date.getHours();
                        const minutes = String(date.getMinutes()).padStart(
                          2,
                          "0"
                        );
                        const ampm = hours >= 12 ? "PM" : "AM";
                        const formattedHours = hours % 12 || 12;

                        return `${day}/${month}/${year} - ${formattedHours}:${minutes} ${ampm}`;
                      })()}
                    </div>
                  </div>
                  <div className="tableRow">
                    <div>Payment Method:</div>
                    <div>{transactionDetails.payment_method}</div>
                  </div>
                  <div className="tableRow">
                    <div>Amount:</div>
                    <div>${transactionDetails.amount}</div>
                  </div>
                </div>
              )}
              <div className="noteBg">
                Please send this receipt to your cashier, or let them know you
                have completed the payment.
              </div>
              <div className="complitedText">
                DO NOT RESEND PAYMENT TO THIS BITCOIN ADDRESS AGAIN, WE ARE NOT
                RESPONSIBLE FOR ANY LOSSES THAT GET SENT TO THE WRONG BITCOIN
                ADDRESS
              </div>
              <div className="btnsWrap">
                <button
                  className="btn"
                  onClick={() =>
                    handleDownloadReceipt(
                      () => Promise.resolve(transactionDetails),
                      transactionDetails.transaction_id
                    )
                  }
                >
                  <div>Download</div>
                  <img
                    src={theme === "light" ? download : downloadDark}
                    alt="download"
                  />
                </button>
                <button
                  className="btn"
                  onClick={() =>
                    handleShareReceipt(
                      transactionDetails,
                      transactionDetails.transaction_id
                    )
                  }
                >
                  <div>Share</div>
                  <img
                    src={theme === "light" ? share : shareDark}
                    alt="share"
                  />
                </button>
              </div>
            </div>
            <Button
              text={"Back to Deposit"}
              onClick={() => navigate("/deposit")}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default Payment;
